@if (currentMode === FieldMode.READ && !isCreatingEntity) {
  <div class="read-field-container">
    <div [hidden]="!viewToggled"
         [ngClass]="{'no-value': !accessManager.hasAllNeededPermissions(permissionsForEdition)}"
         class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-center">

      <div class="field-label fx-flex-100-33-percent">
        {{ fieldConfig.label }}
        @if (fieldConfig.tooltip) {
          <span [matTooltipPosition]="'below'"
                [matTooltip]="fieldConfig.tooltip" #tooltip="matTooltip" (click)="onClickTooltip(tooltip)">
            <i class="mdi mdi-help-circle tooltip-icon"></i>
          </span>
        }
      </div>

      <div class="field-container fx-flex-100-66-percent fx-layout-col">
        <div (click)="onActivate($event)"
             (keyup.enter)="onActivate($event)"
             tabindex="0"
             [ngClass]="{'read-value':accessManager.hasAllNeededPermissions(permissionsForEdition) &&  preconditionsForEdition, 'computed': !(accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition)}">

          @if (selectedEntities.value?.length > 0) {
            <mat-chip-listbox tabIndex="-1">
              @for (chip of selectedEntities | async; track chip.id) {
                <mat-chip-option
                  class="clickable-field"
                  (click)="onActivate($event)"
                  (keyup.enter)="onActivate($event)">

                  <a (click)="navigateToRelatedEntitySheet(chip.id)">
                    {{ chip.toString() }}
                  </a>

                </mat-chip-option>
              }
            </mat-chip-listbox>
          } @else {
            <span>{{ appConfig.EMPTY_FIELD_VALUE }}</span>
          }

          @if (fieldConfig.suffixType) {
            <span>{{ fieldConfig.suffixType | translate }}</span>
          }

          @if (accessManager.hasAllNeededPermissions(permissionsForEdition)) {
            <span class="overlay-icon">
              @if (preconditionsForEdition) {
                <i class="mdi mdi-pencil selectable"></i>
              } @else {
                <i [matTooltipPosition]="'below'"
                   [matTooltip]="'TOOLTIP.READ_ONLY_VALUE' | translate"
                   class="mdi mdi-pencil-off tooltip-icon"></i>
              }
            </span>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (currentMode === FieldMode.EDIT || isCreatingEntity) {
  <div>
    <div [hidden]="!editToggled || !viewToggled"
         class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">

      @if (!isCreatingEntity) {
        <div class="field-label fx-flex-100-33-percent">
          {{ fieldConfig.label }}
          @if (fieldConfig.tooltip) {
            <span [matTooltipPosition]="'below'"
                  [matTooltip]="fieldConfig.tooltip" #tooltip="matTooltip" (click)="onClickTooltip(tooltip)">
              <i class="mdi mdi-help-circle tooltip-icon"></i>
            </span>
          }
        </div>
      }

      @if (!requiresAsset || !noAsset) {
        @if (filteredOptions$ | async; as filteredOptions) {
          @if (hasRelatedEntities) {
            <div #fieldContainer class="field-container fx-flex-100-66-percent-min-500 fx-layout-col">

              <form autocomplete="off" class="chips-field-builder-form" [formGroup]="form">
                <mat-form-field appearance="outline">

                  <mat-label>{{ fieldConfig.label }}</mat-label>

                  <mat-chip-grid #chipList>
                    @for (chip of (selectedEntities| async | slice: 0:10); track chip.id) {
                      <mat-chip-row (removed)="remove(chip)"
                                    [removable]="true">
                        {{ chip.toString() }}
                        <button matChipRemove>
                          <i class="mdi mdi-close-circle"></i>
                        </button>
                      </mat-chip-row>
                    }

                    @if (selectedEntities.value.length > 10) {
                      {{ 'TOOLTIP.AND_MORE' | translate: {quantity: (selectedEntities.value.length - 10)} }}
                    }

                    <input #inputField #trigger="matAutocompleteTrigger"
                           [required]="fieldConfig.customOptions?.required"
                           formControlName="field"
                           (keyup.escape)="onEscapeCancel($event)"
                           [matAutocomplete]="suggestions"
                           [matChipInputFor]="chipList"
                           [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                           class="chip-input"
                           type="text">
                  </mat-chip-grid>

                  @if (fieldConfig.suffixType) {
                    <span matTextSuffix>{{ fieldConfig.suffixType | translate }}</span>
                  }

                  <mat-autocomplete
                    #suggestions="matAutocomplete"
                    (optionSelected)="add($event.option.value)"
                    [panelWidth]="fieldContainer.offsetWidth - 90">

                    <cdk-virtual-scroll-viewport [itemSize]="appConfig.CDK_VIEWPORT_ITEM_HEIGHT"
                                                 (scrolledIndexChange)="onScroll($event)"
                                                 [appendOnly]="true"
                                                 [maxBufferPx]="2 * appConfig.CDK_VIEWPORT_ITEM_HEIGHT * appConfig.CDK_VIEWPORT_MAXIMUM_ITEM_COUNT"
                                                 [minBufferPx]="appConfig.CDK_VIEWPORT_ITEM_HEIGHT * appConfig.CDK_VIEWPORT_MAXIMUM_ITEM_COUNT"
                                                 [style.height]="viewportHeight">
                      <mat-option *cdkVirtualFor="let fieldValue of filteredOptions" [value]="fieldValue">
                        {{ fieldValue.toString() }}
                      </mat-option>
                    </cdk-virtual-scroll-viewport>

                  </mat-autocomplete>

                  @for (validator of erroredValidators; track validator.type) {
                    <mat-error>
                      {{ 'ERROR.FIELD_' + validator.type | uppercase | translate: {value: validator.definition} }}
                    </mat-error>
                  }
                </mat-form-field>
              </form>

              @if (isSingleField) {
                <div class="save-options">
                  <button (click)="onClickCancel()" (keyup.escape)="onEscapeCancel($event)" class="button">
                    <i class="mdi mdi-close"></i>
                  </button>

                  <button (click)="onClickSave()" (keyup.escape)="onEscapeCancel($event)" [disabled]="!form.valid"
                          class="button save">
                    <i class="mdi mdi-check"></i>
                  </button>
                </div>
              }

            </div>
          } @else {
            <div class="field-container fx-flex-100-66-percent-min-500">
              {{ noRelatedEntitiesMessage | translate }}
            </div>
          }
        }
      } @else {
        <div class="field-container fx-flex-100-66-percent-min-500">
          {{ 'LABEL.NO_ASSET_SELECTED' | translate }}
        </div>
      }
    </div>
  </div>
}
